import React from "react"
import { preserveQueryString } from "../utils/url"

const QueryStringContext = React.createContext("")

export function QueryStringProvider({ location, children }) {
  // Match the static HTML on hydration, then update links from Gatsby's location.
  const [search, setSearch] = React.useState("")
  React.useEffect(() => {
    setSearch(location?.search || "")
  }, [location?.search])

  return (
    <QueryStringContext.Provider value={search}>
      {children}
    </QueryStringContext.Provider>
  )
}

export function usePreserveQueryString() {
  const search = React.useContext(QueryStringContext)
  return (href) => preserveQueryString(href, search)
}

export function wrapPageElement({ element, props }) {
  return (
    <QueryStringProvider location={props.location}>
      {element}
    </QueryStringProvider>
  )
}
